module.exports = __webpack_public_path__ + "gfx/logogo.png";